function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { CheckboxVisibility, ConstrainMode, DetailsHeader, DetailsList, DetailsListLayoutMode } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import { renderNotAvailablePriceUI } from '@shared/utils/pricing';
import { getColumns } from '@shared/components/saasPricingTableBase/saasPricingTableColumns';
import { SaasPricingRow } from '@shared/components/saasPricingTableBase/saasPricingRow';
import { logger } from '@src/logger';
import { getWindow } from '@shared/services/window';
import { useSpzaInstrumentService } from '@shared/hooks';
import { sortingSKUs } from '@shared/utils/appUtils';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
const renderRow = (rowProps)=>/*#__PURE__*/ _jsx(SaasPricingRow, _object_spread({}, rowProps));
const headerStyles = {
    root: {
        height: 20,
        lineHeight: 20,
        paddingBottom: 8
    }
};
const cellStyles = {
    cellExtraRightPadding: 0,
    cellLeftPadding: 0,
    cellRightPadding: 0
};
const sortRows = (rows)=>rows.sort(({ sku: a }, { sku: b })=>sortingSKUs({
            a,
            b
        }));
export const defaultRenderHeader = (headerProps)=>{
    return /*#__PURE__*/ _jsx(DetailsHeader, _object_spread_props(_object_spread({}, headerProps), {
        styles: headerStyles
    }));
};
export const SaasPricingTableBase = ({ app, billingCountry, locale, shouldBlockPrices, onGetInNowClicked, detailsListPropsOverride }, context)=>{
    const { pricingInformation: pricing, futurePricesInformation: futurePrices, entityId } = app;
    const isOneTimePayment = isOneTimePaymentOffer(entityId);
    const skus = (pricing === null || pricing === void 0 ? void 0 : pricing.skus) || [];
    const futurePricesSkus = (futurePrices === null || futurePrices === void 0 ? void 0 : futurePrices.skus) || [];
    const [instrument] = useSpzaInstrumentService();
    const columns = useMemo(()=>getColumns({
            context,
            skus,
            billingCountry,
            onGetInNowClicked,
            shouldBlockPrices,
            locale,
            isOneTimePayment
        }), [
        context,
        skus,
        billingCountry,
        onGetInNowClicked,
        shouldBlockPrices,
        locale
    ]);
    const items = useMemo(()=>sortRows(skus.map((sku)=>{
            const futurePriceSku = futurePricesSkus.find((futureSku)=>futureSku.id === sku.id);
            return {
                sku,
                futurePriceSku
            };
        })), [
        skus,
        futurePricesSkus
    ]);
    useEffect(()=>{
        const { bigId, entityId } = app;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.LongTermSaaS,
            actionModifier: Constants.Telemetry.ActionModifier.LongTermSaasTablePresented,
            details: JSON.stringify({
                bigId,
                entityId
            })
        };
        logger.info(`LongTermSaas PDP table was loaded. bigId: ${bigId}, entityId: ${entityId}`, payload);
        // Using old logger for the transition period
        instrument.probe('logAndFlushTelemetryInfo', payload);
    }, []);
    if (!pricing) {
        return /*#__PURE__*/ _jsx("div", {
            children: context.loc('Loading')
        });
    }
    if (!(skus === null || skus === void 0 ? void 0 : skus.length)) {
        return renderNotAvailablePriceUI(context);
    }
    return /*#__PURE__*/ _jsx(DetailsList, _object_spread({
        items: items,
        columns: columns,
        onRenderRow: renderRow,
        onRenderDetailsHeader: defaultRenderHeader,
        layoutMode: DetailsListLayoutMode.justified,
        checkboxVisibility: CheckboxVisibility.hidden,
        disableSelectionZone: true,
        cellStyleProps: cellStyles,
        constrainMode: ConstrainMode.unconstrained
    }, detailsListPropsOverride));
};
SaasPricingTableBase.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
